(function(){
var LIMIT=10000,cache=null,busy=false,PV=67726962524330,PP=15411820396714;
function $(s,r){return (r||document).querySelector(s)}
function money(c){return '$'+(c/100).toFixed(2)}
function net(cart){var t=cart.total_price;cart.items.forEach(function(i){if(i.variant_id===PV)t-=i.final_line_price});return t}
async function getCart(){return (await fetch('/cart.js')).json()}
async function recs(cart){
  if(cache)return cache;
  var seen={},out=[];seen[PP]=1;cart.items.forEach(function(i){seen[i.product_id]=1});
  var items=cart.items.slice().reverse().slice(0,3);
  for(var k=0;k<items.length;k++){
    try{var j=await (await fetch('/recommendations/products.json?product_id='+items[k].product_id+'&limit=10&intent=related')).json();
      (j.products||[]).forEach(function(p){if(!seen[p.id]&&p.available!==false){seen[p.id]=1;out.push(p)}});
    }catch(e){}
  }
  cache=out;return out;
}
function card(p,remain){
  var a=document.createElement('div');a.className='colo-up';
  var img=document.createElement('a');img.className='colo-up__img';img.href=p.url;
  if(p.featured_image){var im=document.createElement('img');im.src=p.featured_image.replace(/(\.[a-z]+)(\?|$)/i,'_300x300$1$2');im.loading='lazy';im.alt='';img.appendChild(im)}
  var t=document.createElement('a');t.className='colo-up__t';t.href=p.url;t.textContent=p.title;
  var pr=document.createElement('div');pr.className='colo-up__p';pr.textContent=money(p.price);
  if(p.compare_at_price&&p.compare_at_price>p.price*1.5){var s=document.createElement('s');s.textContent=money(p.compare_at_price);pr.appendChild(s)}
  var b;
  if(p.variants&&p.variants.length>1){b=document.createElement('a');b.href=p.url;b.textContent='Choose options'}
  else{b=document.createElement('button');b.type='button';b.textContent='+ Add to cart';b.addEventListener('click',function(){add(p.variants[0].id,b)})}
  b.className='colo-up__btn';
  a.appendChild(img);
  if(remain>0&&p.price>=remain&&p.price<=remain*2.5){var tg=document.createElement('span');tg.className='colo-up__tag';tg.textContent='Free shipping';a.appendChild(tg)}
  a.appendChild(t);a.appendChild(pr);a.appendChild(b);return a;
}
function build(cls,title,sub,list,remain,n){
  var w=document.createElement('div');w.className=cls;
  var h=document.createElement('div');h.className='colo-upsell__head';
  var l=document.createElement('div');var t=document.createElement('h2');t.className='colo-upsell__title';t.textContent=title;l.appendChild(t);
  if(sub){var s=document.createElement('p');s.className='colo-upsell__sub';s.textContent=sub;l.appendChild(s)}
  h.appendChild(l);w.appendChild(h);
  var tr=document.createElement('div');tr.className='colo-upsell__track';
  list.slice(0,n).forEach(function(p){tr.appendChild(card(p,remain))});
  w.appendChild(tr);return w;
}
async function add(id,btn){
  btn.disabled=true;btn.textContent='Adding…';
  var drawer=$('cart-drawer'),onCart=!!$('main[data-template=cart]');
  var body={id:id,quantity:1};
  try{
    if(!onCart&&drawer&&drawer.getSectionsToRender){body.sections=drawer.getSectionsToRender().map(function(s){return s.id});body.sections_url=location.pathname}
    var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    var st=await r.json();
    if(onCart||!st.sections){location.reload();return}
    drawer.renderContents(st);
  }catch(e){btn.disabled=false;btn.textContent='+ Add to cart'}
}
function trust(){
  var box=$('#main-cart-footer .cart__blocks');if(!box||$('.colo-trust',box))return;
  var lock='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>';
  var truck='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 6h13v10H1zM14 10h5l3 3v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
  var chat='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12a8 8 0 01-11.5 7.2L3 21l1.8-6.5A8 8 0 1121 12z"/></svg>';
  var d=document.createElement('div');d.className='colo-trust';
  d.innerHTML='<div class="colo-trust__r">'+lock+'<span><b>Secure checkout</b>Your payment details are encrypted.</span></div><div class="colo-trust__r">'+truck+'<span><b>Free shipping over $100</b>Automatically applied at checkout.</span></div><div class="colo-trust__r">'+chat+'<span><b>Need help?</b><a href="/pages/contact">Contact our team</a></span></div>';
  box.appendChild(d);
}
async function render(){
  if(busy)return;busy=true;
  try{
    var cart=await getCart();
    if(!cart.item_count){return}
    var list=(await recs(cart)).filter(function(p){return !cart.items.some(function(i){return i.product_id===p.id})});
    var remain=Math.max(0,LIMIT-net(cart));
    if(remain>0){var inb=function(p){return p.price>=remain&&p.price<=remain*2.5?0:(p.price<remain?1:2)};list=list.map(function(p,i){return{p:p,i:i}}).sort(function(a,b){return inb(a.p)-inb(b.p)||a.i-b.i}).map(function(x){return x.p})}
    var main=$('main[data-template=cart]');
    if(main){
      var old=$('.colo-upsell',main);if(old)old.remove();
      if(list.length)main.appendChild(build('colo-upsell','You may also like',remain>0?'Add $'+(remain/100).toFixed(2)+' more to unlock free shipping':'Free shipping unlocked — top up your order',list,remain,10));
      trust();
    }
    var dr=$('cart-drawer:not(.is-empty) .drawer__inner');
    if(dr){
      var o=$('.colo-upsell-drawer',dr);if(o)o.remove();
      var f=$('.drawer__footer',dr);
      if(f&&list.length)dr.insertBefore(build('colo-upsell-drawer','Add to your order','',list,remain,6),f);
    }
  }catch(e){}finally{busy=false}
}
var tm;function sched(){clearTimeout(tm);tm=setTimeout(render,400)}
document.addEventListener('DOMContentLoaded',function(){
  render();
  new MutationObserver(function(m){
    function ours(n){return n.nodeType!==1||/colo-/.test(n.className||'')||(n.hasAttribute&&n.hasAttribute('data-colo-ship'))}
    for(var i=0;i<m.length;i++){var t=m[i].target;if(t.closest&&t.closest('.colo-upsell,.colo-upsell-drawer,.colo-trust,[data-colo-ship]'))continue;
      var ch=Array.prototype.slice.call(m[i].addedNodes).concat(Array.prototype.slice.call(m[i].removedNodes));
      if(ch.length&&ch.every(ours))continue;sched();return}
  }).observe(document.body,{childList:true,subtree:true});
});
})();
